import { useCallback, useEffect, useState } from 'react'

import type { InteractionState } from '../types'

export const useCategoryInteraction = () => {
  const [interactionState, setInteractionState] = useState<InteractionState>(null)
  const [isFocused, setIsFocused] = useState(false)
  const [isTextInputFocused, setIsTextInputFocused] = useState(false)

  const resetInteraction = useCallback(() => {
    setInteractionState(null)
    setIsFocused(false)
    setIsTextInputFocused(false)
  }, [])

  useEffect(() => {
    setIsFocused(!!interactionState)
  }, [interactionState])

  return {
    interactionState,
    setInteractionState,
    isFocused,
    isTextInputFocused,
    setIsTextInputFocused,
    resetInteraction,
  }
}
